let FormRange = function (props) {
  let {
    min,
    max,
    step = 1,
    name,
    value,
    disabled = false,
    nullable = false,
    onChange,
    tx = (n) => n.toString()
  } = props;

  let _onChange = function (evt) {
    let value = evt.target.value;

    onChange(value ? +value : null);
  };

  let opts = [];

  for (let i = min; i <= max; i += step) {
    opts.push(<option key={i} value={i}>{tx(i)}</option>);
  }

  if (nullable) {
    opts.unshift(<option key="null"/>);
  }

  return (
    <select name={name} value={value} onChange={_onChange} disabled={disabled}>
      {opts}
    </select>
  );
};

module.exports = FormRange;
